/* eslint-disable react-refresh/only-export-components */
import { FC, ReactNode, createContext, useContext } from 'react'
import { USER_TIME_ZONE } from '../constants/timeZone'
import { formatDate } from '../utils/formatDate'
import { DateTime } from '../types/DateTime'

export type DatesContext = {
  PreferredDateTimeComponent: FC<{
    children: DateTime
    format?: string
    secondaryFormat?: string
    property: string
  }>
  preferredFormatDateFunction: (options: {
    dateTime: DateTime
    format?: string
    property: string
  }) => string
  preferredTimezone: string | undefined
}

export function DatesProvider({
  children,
  PreferredDateTimeComponent = DefaultDateComponent,
  preferredFormatDateFunction = defaultFormat,
  preferredTimezone = defaultContext.preferredTimezone,
}: {
  children: ReactNode
} & Partial<DatesContext>) {
  return (
    <DatesContext.Provider
      value={{ PreferredDateTimeComponent, preferredFormatDateFunction, preferredTimezone }}
    >
      {children}
    </DatesContext.Provider>
  )
}

export function useDatesContext() {
  const routes = useContext(DatesContext)

  if (!routes) {
    throw new Error('DatesProvider required to use useDatesContext')
  }

  return routes
}

// defaults

const DefaultDateComponent: DatesContext['PreferredDateTimeComponent'] = ({ children, format }) => (
  <>{formatDate(children, format)}</>
)

const defaultFormat: DatesContext['preferredFormatDateFunction'] = ({ dateTime, format }) =>
  formatDate(dateTime, format)

const defaultContext: DatesContext = {
  PreferredDateTimeComponent: DefaultDateComponent,
  preferredFormatDateFunction: defaultFormat,
  preferredTimezone: USER_TIME_ZONE,
}

// Context
const DatesContext = createContext<DatesContext>(defaultContext)
